import driverModule from "./driverModule"
import * as angular from "angular"

driverModule.controller("driverController", ["$scope", "sourceEntity", "entity", "entityEditionService", ($scope, sourceEntity, entity, entityEditionService) => {
    $scope.entity = entity
    const updateService = entityEditionService.crudHelper("driver", sourceEntity)
    $scope.save = updateService.save.bind(updateService, entity)
    $scope.saveAndContinue = updateService.save.bind(updateService, entity, true)

    $scope.isCreation = () => {
        return !angular.isNumber($scope.entity.id)
    }
}])
